export default __webpack_public_path__ + "static/media/twitter.e8dabd02.svg";